import layout_row from '../widgets/layout_row/style';
import layout_column from '../widgets/layout_column/style';
import layout_column_new from '../widgets/layout_column_new/style';
import basic_module from '../widgets/basic_module/style';
import basic_picture from '../widgets/basic_picture/style';
import basic_navbar from '../widgets/basic_navbar/style';
import basic_webtitle from '../widgets/basic_webtitle/style';
import basic_vip_header from '../widgets/basic_vip_header/style';
import basic_copyright from '../widgets/basic_copyright/style';
import basic_text from '../widgets/basic_text/style';
import basic_button from '../widgets/basic_button/style';
import full_screen_banner from '../widgets/full_screen_banner/style';
import basic_searchs from '../widgets/basic_searchs/style';
import basic_searchs_results from '../widgets/basic_searchs_results/style';
import basic_map from '../widgets/basic_map/style';
import basic_embed_page from '../widgets/basic_embed_page/style';
import basic_banner from '../widgets/basic_banner/style';
import basic_download from '../widgets/basic_download/style';
import basic_video from '../widgets/basic_video/style';
import basic_list_photos from '../widgets/basic_list_photos/style';
import basic_rich_text from '../widgets/basic_rich_text/style';
import basic_nleavemessage from '../widgets/basic_nleavemessage/style';
import basic_atlas_catalog from '../widgets/basic_atlas_catalog/style';
import basic_product_classification from '../widgets/basic_product_classification/style'
import basic_article_classification from '../widgets/basic_article_classification/style'
import basic_article_list from '../widgets/basic_article_list/style'
import basic_article_info from '../widgets/basic_article_info/style'
import basic_product_display from '../widgets/basic_product_display/style';
import basic_product_detail from '../widgets/basic_product_detail/style'
import basic_plugin_code from '../widgets/basic_plugin_code/style';
import basic_h1 from '../widgets/basic_h1/style';
import basic_crumbs from '../widgets/basic_crumbs/style';
import basic_text_rich_type from '../widgets/basic_text_rich_type/style';
import basic_vip_footer from '../widgets/basic_vip_footer/style';
import basic_language from '../widgets/basic_language/style';
import basic_footnav from '../widgets/basic_footnav/style';
import basic_classification from '../widgets/basic_classification/style';

import basic_notice from '../widgets/basic_notice/style';
import basic_icon_combination from '../widgets/basic_icon_combination/style';
import basic_job from '../widgets/basic_job/style';
import basic_picture_text_swiper from '../widgets/basic_picture_text_swiper/style'
import basic_row_tab from '../widgets/basic_row_tab/style'
import basic_member_register from '../widgets/basic_member_register/style'
import basic_member_center from '../widgets/basic_member_center/style'

// 动态数字
import basic_magic_number from '../widgets/basic_magic_number/style'
import basic_progress from '../widgets/basic_progress/style' // 进度条
import basic_video_display from '../widgets/basic_video_display/style'
import basic_download_display from '../widgets/basic_download_display/style'
import basic_flod_text from '../widgets/basic_flod_text/style' // 折叠文本组件
import basic_development_history from '../widgets/basic_development_history/style';
import basic_video_detail from '../widgets/basic_video_detail/style'; // 视频详情
import basic_zhlanguage from '../widgets/basic_zhlanguage/style';

import basic_floating_frame from '../widgets/basic_floating_frame/style'; // 浮框
import basic_login from '../widgets/basic_login/style'; // 登录
import basic_loginregister from '../widgets/basic_loginregister/style'; // 登录注册的头部
import basic_retrieve_password from '../widgets/basic_retrieve_password/style';
import basic_recommend_list from '../widgets/basic_recommend_list/style'; // 热门推荐
import basic_flod_text_list from '../widgets/basic_flod_text_list/style' // 折叠文本组件

//所有挂件默认样式，打成一个大对象，新增挂件时读取
export default {
  layout_row,
  layout_column,
  layout_column_new,
  basic_module,
  basic_picture,
  basic_navbar,
  basic_webtitle,
  basic_vip_header,
  basic_copyright,
  full_screen_banner,
  basic_searchs,
  basic_searchs_results,
  basic_text,
  basic_button,
  basic_map,
  basic_embed_page,
  basic_banner,
  basic_download,
  basic_video,
  basic_list_photos,
  basic_rich_text,
  basic_nleavemessage,
  basic_atlas_catalog,
  basic_product_classification,
  basic_article_classification,
  basic_article_list,
  basic_article_info,
  basic_product_display,
  basic_product_detail,
  basic_plugin_code,
  basic_h1,
  basic_crumbs,
  basic_text_rich_type,
  basic_vip_footer,
  basic_language,
  basic_footnav,
  basic_classification,
  basic_notice,
  basic_icon_combination,
  basic_job,
  basic_picture_text_swiper,
  basic_row_tab,
  basic_member_register,
  basic_member_center,
  basic_magic_number,
  basic_progress,
  basic_video_display,
  basic_download_display,
  basic_flod_text,
  basic_development_history,
  basic_video_detail,
  basic_zhlanguage,
  basic_floating_frame,
  basic_login,
  basic_loginregister,
  basic_retrieve_password,
  basic_recommend_list,
  basic_flod_text_list
}



// WEBPACK FOOTER //
// ./src/base/style_list_config.js